module.exports = __webpack_public_path__ + "img/ywcj-jjfa_gylsj.b55831a4.png";